const flashPromotionStoragePrefix = 'poddtoppen:flash-promotion';

function parsePositiveInteger(value) {
    const parsed = Number.parseInt(value, 10);

    return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}

function readStoredState(storage, storageKey) {
    try {
        const storedState = JSON.parse(storage.getItem(storageKey) || '{}');

        return storedState && typeof storedState === 'object' ? storedState : {};
    } catch {
        return {};
    }
}

function writeStoredState(storage, storageKey, state) {
    try {
        storage.setItem(storageKey, JSON.stringify(state));

        return true;
    } catch {
        return false;
    }
}

function getStorage(storage) {
    if (storage !== undefined) {
        return storage;
    }

    try {
        return window.localStorage;
    } catch {
        return null;
    }
}

function hidePromotion(promotion) {
    const surface = promotion.querySelector('[data-flash-promotion-surface]');

    surface?.classList.remove('scale-100', 'opacity-100');
    surface?.classList.add('invisible', 'scale-[0.98]', 'opacity-0');
}

function showPromotion(promotion) {
    const surface = promotion.querySelector('[data-flash-promotion-surface]');

    surface?.classList.remove('invisible', 'scale-[0.98]', 'opacity-0');
    surface?.classList.add('scale-100', 'opacity-100');
}

export function initializeFlashPromotions(root = document, storage = undefined) {
    const promotions = root.querySelectorAll('[data-flash-promotion]');
    const resolvedStorage = getStorage(storage);

    promotions.forEach((promotion) => {
        const id = promotion.getAttribute('data-flash-promotion-id');

        if (!id) {
            return;
        }

        const storageKey = `${flashPromotionStoragePrefix}:${id}`;
        const hideAfterInteraction =
            promotion.getAttribute('data-hide-after-interaction') === 'true';
        const hideAfterViews = parsePositiveInteger(
            promotion.getAttribute('data-hide-after-views'),
        );
        const hasHideRules = hideAfterInteraction || hideAfterViews !== null;

        if (!hasHideRules || !resolvedStorage) {
            showPromotion(promotion);
            return;
        }

        const storedState = readStoredState(resolvedStorage, storageKey);
        const currentViews = parsePositiveInteger(storedState.views) ?? 0;

        if (
            (hideAfterInteraction && storedState.interacted === true) ||
            (hideAfterViews !== null && currentViews >= hideAfterViews)
        ) {
            hidePromotion(promotion);
            return;
        }

        showPromotion(promotion);

        const nextState = {
            ...storedState,
            views: currentViews + 1,
        };

        writeStoredState(resolvedStorage, storageKey, nextState);

        const markInteracted = () => {
            if (!hideAfterInteraction) {
                return;
            }

            writeStoredState(resolvedStorage, storageKey, {
                ...nextState,
                interacted: true,
            });
        };
        const cta = promotion.querySelector('[data-flash-promotion-cta]');

        cta?.addEventListener('pointerdown', markInteracted);
        cta?.addEventListener('click', markInteracted);
        cta?.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                markInteracted();
            }
        });
    });
}
